import { Routes } from '@angular/router';
import { authGuard, authMatchGuard } from './guards/auth.guard';
import { UserRole } from '@app/libs/constant';

export const routes: Routes = [
  {
    path: '',
    // canActivate: [AuthenticatedGuard],
    loadChildren: () => import('./pages/home/home.routes').then(m => m.routes),
    canActivate: [authGuard],
    canMatch: [authMatchGuard],
    data: { expectedRoles: [UserRole.ADMIN, UserRole.OPERATOR, UserRole.APPROVER] }
  },
  { path: 'login', loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent) },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];
